export default "__VITE_ASSET__d9587e99__"